import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class Parallax {
    constructor() {
        this.init();
    }

    init() {
        this.parallax();
    }

    parallax() {
        const groups = [
            { selector: "js-parallax-s", y: -50 }, //パララックス小
            { selector: "js-parallax-l", y: -250 }, //パララックス大
        ];

        groups.forEach(({ selector, y }) => {
            gsap.utils.toArray(`.${selector}`).forEach((wrap) => {
                const flag = wrap.dataset.parallax;
                if (flag === "off") {
                    return;
                }
                gsap.to(wrap, {
                    y: y,
                    ease: "none",
                    scrollTrigger: {
                        trigger: "body",
                        start: "top bottom",
                        end: "bottom top",
                        scrub: true,
                    },
                });
            });
        });
    }
}
